import { gql } from '@apollo/client';

import { threadFragment } from '../fragments';

export default gql`
  mutation IncreaseThreadViews($courseId: String!, $threadId: String!) {
    increaseThreadViews(courseId: $courseId, threadId: $threadId, input: {})
      @rest(
        type: "Thread"
        path: "courses/{args.courseId}/threads/{args.threadId}/increase-views"
        method: "PUT"
      ) {
      ...Thread
    }
  }
  ${threadFragment}
`;
